// RingingNotifyIcon.tsx

import React, { useEffect, useRef } from "react"
import { Pressable } from "react-native"
import NotifyIcon from "@/assets/icons/comp-card-alert-icon.svg"
import IsNotifyIcon from "@/assets/icons/comp-card-alert-filled.svg"
import Animated, {
  useSharedValue,
  useAnimatedStyle,
  withSequence,
  withTiming,
  withRepeat,
} from "react-native-reanimated"

interface RingingNotifyIconProps {
  notificationsEnabled: boolean
  onNotify: () => void
}

const RingingNotifyIcon: React.FC<RingingNotifyIconProps> = ({
  notificationsEnabled,
  onNotify,
}) => {
  const rotation = useSharedValue(0)
  const hasMounted = useRef(false) // Track if the component has mounted

  const startRinging = () => {
    rotation.value = withRepeat(
      withSequence(
        withTiming(-25, { duration: 75 }), // rotate left
        withTiming(30, { duration: 75 }), // rotate right
        withTiming(0, { duration: 75 }) // back to initial position
      ),
      3, // repeat the sequence 3 times
      true // alternate the direction
    )
  }

  useEffect(() => {
    // Skip the animation on first mount
    if (hasMounted.current) {
      if (notificationsEnabled) {
        startRinging()
      }
    } else {
      hasMounted.current = true // Set to true after first render
    }
  }, [notificationsEnabled])

  const animatedStyle = useAnimatedStyle(() => {
    return {
      transform: [
        {
          rotate: `${rotation.value}deg`,
        },
      ],
    }
  })

  return (
    <Pressable
      testID={"ring-icon-button"}
      style={({ pressed }) => [{ opacity: pressed ? 0.5 : 1 }]}
      onPress={onNotify}
      hitSlop={8}
    >
      <Animated.View style={animatedStyle}>
        {notificationsEnabled ? (
          <IsNotifyIcon width={20} height={22} />
        ) : (
          <NotifyIcon width={20} height={22} />
        )}
      </Animated.View>
    </Pressable>
  )
}

export default RingingNotifyIcon
